<template>
	<ProductShoppingListControl
		v-model:is-shopping-list-open="isShoppingListOpen"
		:product="shoppingListProduct"
		:disabled="pending"
		:show-picker-toggle="isAuthenticated"
		method="DL_detail"
	/>
</template>

<script setup lang="ts">
	import type {ProductInfo} from '@globus/image-overlay';

	interface Props {
		productInfo: ProductInfo;
	}

	const props = defineProps<Props>();

	const isShoppingListOpen = defineModel<boolean>('isShoppingListOpen', {default: false});
	const {isAuthenticated} = useAuth();
	const {pending, shoppingListProduct} = useLeafletCatalogProduct(() => props.productInfo);
</script>
